import { SocketClient } from '@helpers/socket';

export function useSocket(namespace?: string) {
  return SocketClient.getInstance(namespace);
}
